import { combineEpics } from 'redux-observable';
import groupEpic from './groupEpic';

export default combineEpics(groupEpic);
